const DEFAULT_API_ORIGIN = 'http://127.0.0.1:8000';

const configuredBaseUrl = (
  process.env.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_API_URL ||
  DEFAULT_API_ORIGIN
).replace(/\/+$/, '');

export const API_BASE_URL = configuredBaseUrl.endsWith('/api/v1')
  ? configuredBaseUrl
  : `${configuredBaseUrl}/api/v1`;

export const API_ORIGIN = API_BASE_URL.replace(/\/api\/v1\/?$/, '');

export const apiConfig = {
  baseURL: API_BASE_URL,
  timeout: 20000,
  headers: {
    Accept: 'application/json',
  },
};
